import { Employee } from '../../types';

export interface RaaftFormState {
  passportOffice: string;
  vesselId: string;
  flag: string;
  ownerNationality: string;
  fromPort: string;
  currentLocation: string;
  selectedEmployeeIds: string[];
}

export function buildLetterHtml(
  form: RaaftFormState,
  vesselName: string,
  selectedEmployees: Employee[]
): string {
  const rows = selectedEmployees
    .map(
      (emp, i) => `
        <tr>
          <td>${emp.address || ''}</td>
          <td>${emp.birthDate ? new Date(emp.birthDate).toLocaleDateString('ar-EG') : ''}</td>
          <td>${emp.seamanBookNumber || ''}</td>
          <td>${emp.position || ''}</td>
          <td>${emp.name || ''}</td>
          <td>${i + 1}</td>
        </tr>`
    )
    .join('');

  return `<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8">
  <title>طلب رفت بحارة</title>
  <style>
    @page { margin: 20mm; size: A4; }
    body {
      font-family: 'Arial', 'Tahoma', sans-serif;
      direction: rtl;
      text-align: right;
      font-size: 14px;
      line-height: 1.8;
      margin: 0;
      padding: 30px;
    }
    .header {
      text-align: center;
      margin-bottom: 24px;
      border-bottom: 2px solid #000;
      padding-bottom: 12px;
    }
    .company-name { font-size: 20px; font-weight: bold; }
    .company-sub { font-size: 14px; color: #555; }
    .recipient { margin-bottom: 18px; font-size: 15px; font-weight: bold; }
    .body-text { margin-bottom: 18px; font-size: 14px; line-height: 2; }
    .emp-table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
    }
    .emp-table th, .emp-table td {
      border: 1px solid #000;
      padding: 8px 10px;
      text-align: center;
      vertical-align: middle;
    }
    .emp-table th {
      background: #e0e0e0;
      font-weight: bold;
    }
    .footer-text {
      margin-top: 30px;
      font-size: 14px;
      line-height: 2;
    }
    .signature { margin-top: 40px; font-weight: bold; }
    @media print { body { margin: 0; padding: 20px; } }
  </style>
</head>
<body>
  <div class="header">
    <div class="company-name">شركة بترومارين لدعم المشاريع البحرية</div>
    <div class="company-sub">PetroMarine Offshore Projects Support Co.</div>
  </div>

  <div class="recipient">
    السيد / مدير قسم جوازات ${form.passportOffice}
  </div>

  <div class="body-text">
    <strong>تحية طيبة وبعد ،،،</strong>
  </div>

  <div class="body-text">
    الرجاء من سيادتكم الموافقة علي رفت عدد ${selectedEmployees.length} بحرى من على الوحدة ${vesselName} التابعة لشركة بترومارين لدعم المشاريع البحرية والمسجلة تحت علم ${form.flag} وجنسية المالك ${form.ownerNationality} القادمة من ميناء ${form.fromPort} والمتواجدة حاليا ${form.currentLocation}
  </div>

  <table class="emp-table">
    <thead>
      <tr>
        <th>العنوان</th>
        <th>تاريخ الميلاد</th>
        <th>رقم الجواز البحري</th>
        <th>الوظيفة</th>
        <th>الاسم</th>
        <th>م</th>
      </tr>
    </thead>
    <tbody>
      ${rows || '<tr><td colspan="6">لا يوجد بحارة مختارين</td></tr>'}
    </tbody>
  </table>

  <div class="footer-text">
    ولسيادتكم جزيل الشكر
  </div>

  <div class="signature">
    مقدمة لسيادتكم توكيل سيلفرسي
  </div>
</body>
</html>`;
}

export function buildTemplatePrintHtml(subject: string, content: string): string {
  return `<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8">
  <title>${subject}</title>
  <style>
    @page { margin: 20mm; size: A4; }
    body { font-family: 'Arial','Tahoma',sans-serif; direction: rtl; text-align: right; font-size: 14px; line-height: 1.8; padding: 30px; }
    .header { text-align: center; margin-bottom: 24px; border-bottom: 2px solid #000; padding-bottom: 12px; }
    .company-name { font-size: 20px; font-weight: bold; }
    .company-sub { font-size: 14px; color: #555; }
    .content { white-space: pre-line; margin: 20px 0; }
    .footer { margin-top: 40px; text-align: center; font-size: 12px; color: #666; border-top: 1px solid #ddd; padding-top: 20px; }
    @media print { body { margin: 0; padding: 20px; } }
  </style>
</head>
<body>
  <div class="header">
    <div class="company-name">شركة بترومارين لدعم المشاريع البحرية</div>
    <div class="company-sub">PetroMarine Offshore Projects Support Co.</div>
  </div>
  <div class="content">${content}</div>
  <div class="footer"><p>تم إنشاء هذه الرسالة بواسطة نظام Petromarine ERP</p></div>
</body>
</html>`;
}
